import React from 'react';
import {calculateStrokeDashoffset} from "../../../../../../../../common/hook/calcul";

interface RadialStatisticItemProps {
    label: string;
    value: number | undefined;
    gradientId: string;
    id: string;
}

export const RadialStatisticItem: React.FC<RadialStatisticItemProps> = ({ label, value, gradientId, id }) => (
    <div className="radial-statistic-item">
        <div className="radial-statistic">
            <span className="percents">{value}%</span>
            <svg width="60" height="60" className="radial-progress">
                <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
                    <stop offset="0%" stopColor="rgba(193, 232, 111, 1)"></stop>
                    <stop offset="50%" stopColor="rgba(239, 231, 45, 1)"></stop>
                    <stop offset="100%" stopColor="rgba(255, 110, 109, 1)"></stop>
                </linearGradient>
                <circle
                    r="28"
                    cx="30"
                    cy="30"
                    className="external-circle"
                    strokeWidth="4"
                    fill="#fff"
                    stroke={`url(#${gradientId})`}
                    strokeDashoffset={value !== undefined ? calculateStrokeDashoffset(value) : '0'}
                    id={id}
                ></circle>
            </svg>
        </div>
        <span className="radial-statistic-text">{label}</span>
    </div>
);
